import { Capacitor } from '@capacitor/core';
import {
  joinOriginPath,
  stripTrailingSlash,
} from '@up2stay/up2promo-commons/auth';

/**
 * Gets the origin URL for redirect URLs.
 * For Capacitor native devices, uses app.up2promo.com instead of the native origin.
 * For web browsers, uses the current window location origin.
 *
 * @returns The origin URL (e.g., "https://app.up2promo.com" or "https://example.com")
 */
export function getRedirectOrigin(): string {
  // Check if we're running in Capacitor native platform
  if (typeof window !== 'undefined' && Capacitor.isNativePlatform()) {
    return 'https://app.up2promo.com';
  }

  // For web browsers, use the current origin
  if (typeof window !== 'undefined') {
    return stripTrailingSlash(window.location.origin);
  }

  // Fallback for SSR (shouldn't happen for redirect URLs, but handle gracefully)
  return '';
}

/**
 * Builds a redirect URL from a relative path.
 * Handles Capacitor native devices by using app.up2promo.com as origin.
 * Locale is now managed in Zustand, so we don't add it to the URL.
 *
 * @param path - Relative path (e.g., "/auth/login" or "auth/login")
 * @param _locale - Deprecated: locale is now managed in Zustand, this parameter is ignored
 * @returns Full URL (e.g., "https://app.up2promo.com/auth/login")
 */
export function buildRedirectUrl(path: string, _locale?: string): string {
  return joinOriginPath(getRedirectOrigin(), path);
}
